import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import {
  SENSOR_TOWER_TAG_KEYS,
  APPMAGIC_TAG_KEYS,
  APPMAGIC_TAG_MAP,
  START_RELEASE_TIME,
  END_RELEASE_TIME,
  APPMAGIC_TAG_DEFAULT_VALUES,
  RETENTION_D_RANGE_KEYS,
  buildEmptyNumberRangeDefaults,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { REVENUE_SCOPE_VALUES, getAdjustedRevenueValue } from '@intelligence/utils/revenueScope';
import { toDateTypeLy, toDateTypeNor } from '@/pages/intelligence/utils/common';
import {
  formatKpiTrendsHourlyDateTime,
  isKpiTrendsHourlyDateType,
  KPI_TRENDS_HOURLY_SOURCE_METRICS,
  KPI_TRENDS_HOURLY_CCU_METRIC,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/const';
import {
  getSourceMetricsByValue,
  DEFAULTKPITRENDSSHOWRTLIST,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/components/MetricsSelection/config';
import moment from 'moment';
import {
  FilterTimeType,
  isValidDate,
  handleMetricRangeFilter,
  handleGenreFilterParams,
} from '@intelligence/utils/filterUtils';
import { STORERANK_METRICS_OPTIONS_LIST } from '@/pages/intelligence/_config/storeRank/config';
import { buildSensorTowerTagsParams } from '@intelligence/v3/utils/topcharts';
import { CONSOLE_PLATFORMS } from '@intelligence/_config/storeRank/config';
import { componentDefault } from '@intelligence/components/Filter/FilterBase/FilterList';
import { pageParamsFormatMap } from '@intelligence/components/Filter/util';
import { merge, rest } from 'lodash-es';
import type {
  ITopChartsFilterParams,
  ITopChartsApiFilterForm,
  IMetricTableFilterConfig,
  IArpuRangeParams,
  IActiveUsersRangeParams,
  IDownloadsRangeParams,
  IMetricFilterBySource,
} from './types';
export const commonMobileDefaultFilterValue = {
  [filterKeyMap.MY_FILTER]: {
    value: '',
  },
  [filterKeyMap.RANGE_TIME]: {
    type: 'month',
    value: ['', ''],
  },
  [filterKeyMap.RELEASE_TIME]: {
    value: ['', ''],
  },
  [filterKeyMap.REGION]: {
    regions: [],
    markets: ['global'],
    type: 'market',
  },
  [filterKeyMap.COMPOSED_COUNTRY_SELECT]: {
    value: {
      type: 'single',
      countries: ['us'],
    },
  },
  [filterKeyMap.DATASOURCE]: {
    value: ['sensortower', 'appannie'],
  },
  [filterKeyMap.PLATFORM]: { value: ['appstore', 'googleplay'] },
  [filterKeyMap.ALL_COMPANYS]: { value: [] },
  [filterKeyMap.REVENUE_SCOPE]: { value: REVENUE_SCOPE_VALUES.EXCLUDING },
  [filterKeyMap.REVENUE_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.ARPU_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.ACTIVE_USERS_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.DOWNLOADS_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.REVENUE_GROWTH]: { value: { opt: '', value: '' } },
  [filterKeyMap.PLAN]: { value: 'All' },
  // [filterKeyMap.PHEAD_RANG]: { value: [55, 100] },
  [filterKeyMap.GENRETOR]: {
    source: 'iegg',
    mainGenres: [],
    subGenres: [],
  },
  sensor_tower_tag_art_style: {
    value: [],
  },
  sensor_tower_tag_camera_pov: {
    value: [],
  },
  sensor_tower_tag_product_model: {
    value: [],
  },
  sensor_tower_tag_setting: {
    value: [],
  },
  sensor_tower_tag_tags: {
    value: [],
  },
  sensor_tower_tag_theme: {
    value: [],
  },
  sensor_tower_tag_monetization: {
    value: [],
  },
  [filterKeyMap.GAME_ENGINE]: {
    value: [],
    logic: 'OR',
  },
  [filterKeyMap.ALL_Games]: {
    value: [],
    keywords: '',
    isSearchAll: true,
    checkedList: [],
  },
};

export const commonMobileMauReDownDefaultFilterValue = {
  [filterKeyMap.MY_FILTER]: {
    value: '',
  },
  [filterKeyMap.RANGE_TIME]: {
    type: 'month',
    value: ['', ''],
  },
  [filterKeyMap.RELEASE_TIME]: {
    value: ['', ''],
  },
  [filterKeyMap.REGION]: {
    regions: [],
    markets: ['global'],
    type: 'market',
  },
  [filterKeyMap.COMPOSED_COUNTRY_SELECT]: {
    value: {
      type: 'single',
      countries: ['us'],
    },
  },
  [filterKeyMap.DATASOURCE]: {
    value: ['sensortower'],
    // value: ['sensortower', 'appannie'],
  },
  [filterKeyMap.PLATFORM]: { value: ['appstore', 'googleplay'] },
  [filterKeyMap.ALL_COMPANYS]: { value: [] },
  [filterKeyMap.REVENUE_SCOPE]: { value: REVENUE_SCOPE_VALUES.EXCLUDING },
  [filterKeyMap.REVENUE_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.ARPU_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.ACTIVE_USERS_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.DOWNLOADS_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.REVENUE_GROWTH]: { value: { opt: '', value: '' } },
  [filterKeyMap.PLAN]: { value: 'All' },
  // [filterKeyMap.PHEAD_RANG]: { value: [55, 100] },
  [filterKeyMap.GENRETOR]: {
    source: 'iegg',
    mainGenres: [],
    subGenres: [],
  },
  sensor_tower_tag_art_style: {
    value: [],
  },
  sensor_tower_tag_camera_pov: {
    value: [],
  },
  sensor_tower_tag_product_model: {
    value: [],
  },
  sensor_tower_tag_setting: {
    value: [],
  },
  sensor_tower_tag_tags: {
    value: [],
  },
  sensor_tower_tag_theme: {
    value: [],
  },
  sensor_tower_tag_monetization: {
    value: [],
  },
  [filterKeyMap.GAME_ENGINE]: {
    value: [],
    logic: 'OR',
  },
  [filterKeyMap.ALL_Games]: {
    value: [],
    keywords: '',
    isSearchAll: true,
    checkedList: [],
  },
  ...APPMAGIC_TAG_DEFAULT_VALUES,
};

export const commonMobileRetentionDefaultFilterValue = {
  ...commonMobileDefaultFilterValue,
  ...APPMAGIC_TAG_DEFAULT_VALUES,
  [filterKeyMap.GENRETOR]: {
    source: 'sensortower',
    mainGenres: [],
    subGenres: [],
  },
  ...buildEmptyNumberRangeDefaults(RETENTION_D_RANGE_KEYS),
};

export const commonMobileRPDDefaultFilterValue = {
  [filterKeyMap.MY_FILTER]: {
    value: '',
  },
  [filterKeyMap.RANGE_TIME]: {
    type: 'month',
    value: ['', ''],
  },
  [filterKeyMap.RELEASE_TIME]: {
    value: ['', ''],
  },
  [filterKeyMap.REGION]: {
    regions: [],
    markets: ['global'],
    type: 'market',
  },
  [filterKeyMap.COMPOSED_COUNTRY_SELECT]: {
    value: {
      type: 'single',
      countries: ['us'],
    },
  },
  [filterKeyMap.DATASOURCESIM]: {
    value: 'sensortower',
  },
  [filterKeyMap.PLATFORM]: { value: ['appstore', 'googleplay'] },
  [filterKeyMap.ALL_COMPANYS]: { value: [] },
  [filterKeyMap.REVENUE_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.ARPU_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.ACTIVE_USERS_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.DOWNLOADS_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.RPD_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.REVENUE_GROWTH]: { value: { opt: '', value: '' } },
  [filterKeyMap.PLAN]: { value: 'All' },
  [filterKeyMap.GENRETOR]: {
    source: 'sensortower',
    mainGenres: [],
    subGenres: [],
  },
  sensor_tower_tag_art_style: {
    value: [],
  },
  sensor_tower_tag_camera_pov: {
    value: [],
  },
  sensor_tower_tag_product_model: {
    value: [],
  },
  sensor_tower_tag_setting: {
    value: [],
  },
  sensor_tower_tag_tags: {
    value: [],
  },
  sensor_tower_tag_theme: {
    value: [],
  },
  sensor_tower_tag_monetization: {
    value: [],
  },
  [filterKeyMap.GAME_ENGINE]: {
    value: [],
    logic: 'OR',
  },
  [filterKeyMap.ALL_Games]: {
    value: [],
    keywords: '',
    isSearchAll: true,
    checkedList: [],
  },
  ...APPMAGIC_TAG_DEFAULT_VALUES,
};

export const steamGamesOverlapDefaultFilterValue = {
  [filterKeyMap.ALL_Games]: {
    value: [],
    keywords: '',
    isSearchAll: true,
    checkedList: [],
  },
  [filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO]: {
    value: {
      engagementLevelA: 'all',
      engagementLevelB: 'all',
    },
  },
  /* [filterKeyMap.ENGAGELEVEL_SEGEMENT]: {
    value: 'all',
  }, */
};

export const steamGamesOverlapDefaultList = [
  {
    savePopupVisble: 1,
    key: filterKeyMap.ALL_Games,
    params: { entity_type: 'pc', game_type: 'current_game' },
    notSelectTips: 'dbi_compare_pcconsole_game_selection_empty',
  },
  {
    savePopupVisble: 1,
    key: filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO,
  },
];

export const STEAMOVERLAPMETIRCSLIST = [
  'p&p overlap affinity',
  'p&w overlap affinity',
  'w&p overlap affinity',
  'w&w overlap affinity',
];

export const commonPCConsoleDefaultFilterValue = {
  [filterKeyMap.MY_FILTER]: {
    value: '',
  },
  [filterKeyMap.RELEASE_TIME]: {
    value: ['', ''],
  },
  [filterKeyMap.ALL_COMPANYS]: { value: [] },
  [filterKeyMap.STEAM_TAGS]: { value: [] },
  [filterKeyMap.GAME_MODE]: { value: [] },
  [filterKeyMap.PUBLISHER]: {
    value: 'NETWORK',
  },
  [filterKeyMap.GENRETOR]: {
    source: 'iegg',
    mainGenres: [],
    subGenres: [],
  },
  // [filterKeyMap.DIGITAL_SEGEMENT]: { value: 'All' },
  [filterKeyMap.DIGITAL_SEGMENT_MULTIPLE]: {
    value: ['All'],
  },
  [filterKeyMap.ENGAGELEVEL_SEGEMENT]: { value: '2h' },
  [filterKeyMap.ALL_Games]: {
    value: [],
    keywords: '',
    isSearchAll: true,
    checkedList: [],
  },
  [filterKeyMap.DIGITAL_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.PCU_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.PHYSICAL_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.PRICE_RANGE]: { value: { min: '', max: '' } },
  [filterKeyMap.PREMIUM_RANGE]: { value: { min: '', max: '' } },

  [filterKeyMap.REGION]: {
    regions: [],
    markets: ['global'],
    type: 'market',
  },
  [filterKeyMap.RANGE_TIME]: {
    type: 'month',
    value: ['', ''],
  },
};

// 处理全局通用的筛选器至接口参数
export const topchartFilterUndefinedValues = (filterForm: any) => {
  const generFormKeys = ['genre', 'sub_genre', 'genre_source', 'iegg_genre_req'];
  if (typeof filterForm !== 'object') {
    return filterForm;
  }
  Object.keys(filterForm).forEach((key) => {
    // 过滤掉undefined的值,但品类的undefine是要的
    if (!generFormKeys.includes(key) && filterForm[key] === undefined) {
      delete filterForm[key];
    }
    // SENSOR_TOWER_TAG_KEYS对应的值不需要，需要的在外面用了sensortower_tag_filter
    if (SENSOR_TOWER_TAG_KEYS.includes(filterForm[key])) {
      delete filterForm[key];
    }
  });
  return filterForm;
};

// 处理全局通用的时间筛选器时间值给接口参数
export const getCommonTimeFilterValues = (filterValue: any, indexKey: any) => {
  const rangeTimeValue = filterValue?.rangeTime?.value || [];
  const dateTemp =
    Array.isArray(rangeTimeValue) && rangeTimeValue?.length > 1 ? rangeTimeValue[indexKey] : '';
  if (isValidDate(dateTemp)) {
    const dateValue =
      toDateTypeNor[filterValue?.rangeTime?.type] === 'month'
        ? `${moment(dateTemp).format('YYYY-MM')}-01`
        : moment(dateTemp).format('YYYY-MM-DD');
    return dateValue;
  }
  return '';
};

const filterTagParams = ({
  fields,
  filterParams,
  optionsLength,
}: {
  fields: string;
  filterParams: any;
  optionsLength: number;
}) => {
  const valueLength = filterParams?.[fields]?.length;
  return valueLength && valueLength === optionsLength ? [] : filterParams?.[fields];
};

const getCheckedListEntityIds = (checkedList: any[], entityType: string) => {
  if (!Array.isArray(checkedList) || checkedList.length === 0 || !entityType) {
    return [];
  }

  const ids = new Set<string>();
  checkedList.forEach((item) => {
    const typeId = item?.typeIdList?.find((typeItem: any) => typeItem?.type === entityType)?.id;
    if (typeId) {
      ids.add(typeId);
      return;
    }

    if (item?.entityType === entityType || item?.entity_type === entityType) {
      const itemId = item?.id || item?.game_id || item?.unified_id;
      if (itemId) {
        ids.add(itemId);
      }
    }
  });

  return Array.from(ids);
};

const getFilterIds = (filterParams: any, entityType: string, isStudio: boolean) => {
  const filterIds = filterParams?.filter_ids;
  if (!entityType || isStudio) {
    return filterIds;
  }

  const entityTypesIdsObj = filterParams?.entityTypesIdsObj || {};
  const entityTypeIds = entityTypesIdsObj?.[entityType];
  const hasEntityTypeIds = Array.isArray(entityTypeIds) && entityTypeIds.some(Boolean);
  if (hasEntityTypeIds) {
    return entityTypeIds;
  }

  const checkedList = filterParams?.checkedList;
  const checkedListEntityIds = getCheckedListEntityIds(checkedList, entityType);
  if (checkedListEntityIds.length > 0) {
    return checkedListEntityIds;
  }

  const hasCheckedListWithTypeIds =
    Array.isArray(checkedList) &&
    checkedList.some((item) => Array.isArray(item?.typeIdList) && item.typeIdList.length > 0);
  if (hasCheckedListWithTypeIds) {
    return entityTypeIds || [];
  }

  return filterIds;
};

const getAllgamesFilterListParams = (filterParams: any, entityType: string, isStudio = false) => {
  const allGamesParams = {
    isSearchAll: undefined,
    checkedList: undefined,
    entityTypesIdsObj: undefined,
    filter_ids: getFilterIds(filterParams, entityType, isStudio),
  };
  return allGamesParams;
};

export const handleMetricTableFilterParamsToApi = (
  filterParams: any,
  entityType: string,
  extendConfig: { allSteamTagLength: number; allGameModeLength: number; allGameEngineLength?: number },
) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const allGamesParams = getAllgamesFilterListParams(filterParams, entityType) || {};

  const { allSteamTagLength, allGameModeLength, allGameEngineLength } = extendConfig || {};

  const steamTag = filterTagParams({
    fields: 'steam_tag',
    filterParams,
    optionsLength: allSteamTagLength,
  });
  const gameMode = filterTagParams({
    fields: 'game_mode',
    filterParams,
    optionsLength: allGameModeLength,
  });
  const gameEngine = filterTagParams({
    fields: 'game_engine',
    filterParams,
    optionsLength: allGameEngineLength,
  });

  const filterForm: any = {
    ...filterParams,
    // region_type: filterValue[filterKeyMap.REGION]?.region_type, //默认都是market
    regions: filterParams?.regions,
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    gsd_types: filterParams?.gsd_types,
    genre: filterParams?.genre,
    sub_genre: filterParams?.sub_genre,
    genre_source: filterParams?.genre_source,
    iegg_genre_req: filterParams?.iegg_genre_req,

    start_release_time: filterParams?.start_release_time,
    end_release_time: filterParams?.end_release_time,
    company: filterParams?.company || [],
    segment: filterParams?.segment,
    metric_filter: filterParams?.metric_filter,
    device: filterParams?.device,

    // Steam Tags、Game Mode、Game Engine 全选时传 []
    steam_tag: steamTag,
    game_mode: gameMode,
    game_engine: gameEngine,
    game_engine_relation: (filterParams?.game_engine_relation || 'OR').toLowerCase(),

    ...allGamesParams,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleStudioCompetitorFilterParamsToApi = (filterParams: any, entityType: string) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const allGamesParams = getAllgamesFilterListParams(filterParams, entityType, true) || {};
  const filterForm: any = {
    // region_type: filterValue[filterKeyMap.REGION]?.region_type, //默认都是market
    regions: filterParams?.regions,
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    device: filterParams?.device,
    // platforms: filterParams?.competitor_platform,
    ...allGamesParams,
  };
  return topchartFilterUndefinedValues(filterForm);
};

/** 四源品类（含 App Magic）→ filter 内结构，与 Demographics / 休闲页一致 */
export const buildTopChartsMultiSourceGenreFilterBlock = (filterParams: any) => {
  const appmagicGenre = filterParams?.appmagic_genre || [];
  const filterGenres: any = {
    iegg_genre:
      filterParams?.iegg_genre_req ||
      filterParams?.iegg_genre ||
      [],
    appannie_genre: filterParams?.appannie_genre || [],
    sensortower_genre: filterParams?.sensortower_genre || [],
  };
  if (appmagicGenre.length > 0) {
    const formatAppMagicGenres = (list: any[]): any[] => {
      if (!Array.isArray(list) || list.length === 0) return [];
      return list.map((item: any) => ({
        name: item?.value || '',
        children: formatAppMagicGenres(item?.children),
      }));
    };
    filterGenres.app_magic = {
      relation: 'or',
      tags: formatAppMagicGenres(appmagicGenre),
    };
  }
  return filterGenres;
};

/** 仅提取有值的新增筛选字段（AppMagic / IGDB / metric range） */
export const buildTopChartsNewMobileFilterBlock = (
  filterParams: any,
  withMetricFilter = false,
): Record<string, any> => {
  const block: Record<string, any> = {};

  const appMagicTags = filterParams?.app_magic_tags || {};
  const hasAppMagicTags = Object.values(appMagicTags).some(
    (values) => Array.isArray(values) && values.length > 0,
  );
  if (hasAppMagicTags) {
    block.app_magic_tags = appMagicTags;
  }

  const gameEngine = filterParams?.game_engine || [];
  if (gameEngine.length > 0) {
    block.game_engine = gameEngine;
    block.game_engine_relation = (filterParams?.game_engine_relation || 'OR').toLowerCase();
  }

  if (withMetricFilter) {
    const metricFilterObj = filterParams?.metric_filter;
    if (metricFilterObj && typeof metricFilterObj === 'object') {
      const flattened = Object.values(metricFilterObj).flatMap(value =>
        Array.isArray(value) && value.length ? value : [],
      );
      if (flattened.length > 0) {
        block.metric_filter = flattened;
      }
    }
  }

  return block;
};

/**
 * 合并新增筛选字段到 filter：
 * - 页面已有 filter（如 Demographics）→ 只追加有值的新字段，保留原有 filter 结构
 * - 页面原本无 filter → 仅在有新增筛选值时才返回 filter，避免影响旧接口
 */
export const mergeTopChartsNewMobileFilter = (
  filterParams: any,
  withMetricFilter = false,
  existingFilter?: Record<string, any>,
): Record<string, any> => {
  const newBlock = buildTopChartsNewMobileFilterBlock(filterParams, withMetricFilter);

  if (existingFilter) {
    return { filter: { ...existingFilter, ...newBlock } };
  }

  if (Object.keys(newBlock).length === 0) {
    return {};
  }

  return { filter: newBlock };
};

/** 合并 API 参数前去掉 fetchParams 上可能残留的 filter，避免清空新增筛选后旧 filter 被带入 */
export const stripFetchParamsFilter = (params: Record<string, any>) => {
  const next = { ...params };
  delete next.filter;
  return next;
};

/** 四源品类应只出现在 filter 内，去掉 getFilterValueParams 铺到根级的重复字段 */
export const omitMultiSourceGenreRootKeys = (params: Record<string, any>) => {
  const next = { ...params };
  [
    'appannie_genre',
    'sensortower_genre',
    'iegg_genre',
    'appmagic_genre',
    'genre',
    'sub_genre',
  ].forEach(key => {
    delete next[key];
  });
  return next;
};

export const handleDemographicsFilterParamsToApi = (filterParams: any, entityType: string) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const allGamesParams = getAllgamesFilterListParams(filterParams, entityType) || {};

  // 品类筛选器：
  // - 外层继续兼容旧的 genre/sub_genre/genre_source/iegg_genre_req（不动旧逻辑）
  // - 新增的 4 源品类（含 App Magic 四级）只放到 filter 里，结构与休闲页保持一致
  const filterGenres = buildTopChartsMultiSourceGenreFilterBlock(filterParams);

  // sensortower_tag_filter 转换为 {name, children} 结构放入 filter.tags
  const filterTags = buildSensorTowerTagsParams(filterParams?.sensortower_tag_filter);

  // Data.ai（非 sensortower）的 end_date 需要转为月初（后端要求 start_date/end_date 都是月初格式）
  const rawEndDate = filterParams?.end_date;
  const fixedEndDate = rawEndDate && filterParams?.data_sources !== 'sensortower'
    ? moment(rawEndDate).startOf('month').format('YYYY-MM-DD')
    : rawEndDate;

  const filterForm: any = {
    markets: filterParams?.regions,
    // date: filterParams?.start_date, // demographics要
    start_date: filterParams?.start_date,
    end_date: fixedEndDate,

    // legacy
    genre: filterParams?.genre,
    sub_genre: filterParams?.sub_genre,
    genre_source: filterParams?.genre_source,
    iegg_genre_req: filterParams?.iegg_genre_req,

    // 新增：后端新接口使用的 filter 结构（始终传 object；未选时传空数组字段）
    filter: {
      ...filterGenres,
      companies: filterParams?.company || [],
      tags: filterTags,
      start_release_date: filterParams?.start_release_time,
      end_release_date: filterParams?.end_release_time,
      ...buildTopChartsNewMobileFilterBlock(filterParams),
    },

    source: filterParams?.data_sources,
    start_release_date: filterParams?.start_release_time,
    end_release_date: filterParams?.end_release_time,
    platforms: filterParams?.platforms,
    sensortower_tag_filter: filterParams?.sensortower_tag_filter || [],
    ...allGamesParams,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleOverlapFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    markets: filterParams?.regions,
    // date: filterParams?.start_date,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    genre: filterParams?.genre,
    sub_genre: filterParams?.sub_genre,
    genre_source: filterParams?.genre_source,
    iegg_genre_req: filterParams?.iegg_genre_req,

    start_release_time: filterParams?.start_release_time,
    end_release_time: filterParams?.end_release_time,
    company: filterParams?.company || [],
    platforms: filterParams?.platforms,
    // 新增：支持三个数据源的品类
    iegg_genre: filterParams?.iegg_genre || [],
    sensortower_genre: filterParams?.sensortower_genre || [],
    appannie_genre: filterParams?.appannie_genre || [],
    // 新增，Mobile Overlap筛选器
    mobile_overlap: filterParams?.mobileOverlap,
    // 新增：添加SensorTower Tag参数（使用具体字符串key）
    sensortower_tag_filter: filterParams?.sensortower_tag_filter || [],
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleOverlapSteamGameFilterParamsToApi = (fetchParams: any, filterValue: any) => {
  if (JSON.stringify(filterValue) === '{}') {
    return fetchParams;
  }

  const filterForm: any = {
    ...fetchParams,
    engagement_level_a: filterValue?.engageLevel_segement_two?.value?.engagementLevelA || 'all',
    engagement_level_b: filterValue?.engageLevel_segement_two?.value?.engagementLevelB || 'all',
    isSearchAll: filterValue?.allGames?.isSearchAll,
    filter_search_name: filterValue?.allGames?.isSearchAll ? filterValue?.allGames?.keywords : '',
    filter_ids: filterValue?.allGames?.isSearchAll ? [] : filterValue?.allGames?.value,
    page: 1,
    page_size: 100,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleOverlapSteamGameDetailFilterParamsToApi = (
  fetchParams: any,
  filterValue: any,
) => {
  if (JSON.stringify(filterValue) === '{}') {
    return fetchParams;
  }

  // 4-segment 映射：segment key -> page_name
  const SEGMENT_TO_PAGE_NAME: Record<string, string> = {
    played_play: 'played',
    played_wishlist: 'played',
    wishlisted_play: 'wishlisted',
    wishlisted_wishlist: 'wishlisted',
  };

  // 4-segment 对应的 metric_filter metric key
  const SEGMENT_METRIC_FILTER_KEY: Record<string, string> = {
    played_play: 'played & play',
    played_wishlist: 'played & wishlist',
    wishlisted_play: 'wishlisted & play',
    wishlisted_wishlist: 'wishlisted & wishlist',
  };

  // 4-segment 对应的默认 metric_filter value
  const SEGMENT_METRIC_FILTER_DEFAULT: Record<string, { opt: string; value: number; }> = {
    played_play: { opt: '>', value: 20 },
    played_wishlist: { opt: '>', value: 4 },
    wishlisted_play: { opt: '>', value: 20 },
    wishlisted_wishlist: { opt: '>', value: 20 },
  };

  const overlapSegment = filterValue?.overlapSteam_players?.value || 'played_play';
  const pageName = SEGMENT_TO_PAGE_NAME[overlapSegment] || 'played';

  // 4-segment engagement level 逻辑：
  // played_play: engagement_level_a (Game A) + engagement_level_b (Game B) 都发送
  // played_wishlist: 仅发送 engagement_level_a (Game A)
  // wishlisted_play: 仅发送 engagement_level_b (Game B)
  // wishlisted_wishlist: 都不发送
  let engagementLevelA = 'all';
  let engagementLevelB = 'all';

  if (overlapSegment === 'played_play') {
    engagementLevelA = filterValue?.engageLevel_segement_two?.value?.engagementLevelA || 'all';
    engagementLevelB = filterValue?.engageLevel_segement_two?.value?.engagementLevelB || 'all';
  } else if (overlapSegment === 'played_wishlist') {
    engagementLevelA = filterValue?.engageLevel_segement_two?.value?.engagementLevelA || 'all';
    engagementLevelB = 'all';
  } else if (overlapSegment === 'wishlisted_play') {
    engagementLevelA = 'all';
    engagementLevelB = filterValue?.engageLevel_segement?.value || 'all';
  } else {
    // wishlisted_wishlist: 都不需要
    engagementLevelA = 'all';
    engagementLevelB = 'all';
  }

  // 构建 metric_filter：4-segment 只需要一条
  const metricFilterKey = SEGMENT_METRIC_FILTER_KEY[overlapSegment];
  const metricFilterDefault = SEGMENT_METRIC_FILTER_DEFAULT[overlapSegment] || { opt: '>', value: 0 };
  const revenueGrowthValue = filterValue?.revenueGrowth?.value;
  const revenueGrowthFilterValue =
    revenueGrowthValue?.value === '' || revenueGrowthValue?.value == null
      ? 0
      : revenueGrowthValue?.value;

  const metricFilter = metricFilterKey
    ? [
      {
        metric: metricFilterKey,
        opt: revenueGrowthValue?.opt || metricFilterDefault.opt,
        value: revenueGrowthFilterValue,
      },
    ]
    : [];


  const steamTagValue = filterValue?.steam_tag?.value || [];
  const steamTagRelation = (filterValue?.steam_tag?.logic || 'AND').toLowerCase();
  const steamTagParams = {
    steam_tag: steamTagValue,
    steam_tag_relation: steamTagRelation,
  };

  const genreParams = handleGenreFilterParams(
    pageParamsFormatMap[filterKeyMap.GENRETOR]?.(filterValue?.genretor, filterKeyMap.GENRETOR),
  );

  const filterForm: any = {
    ...fetchParams,
    page_name: pageName,
    engagement_level_a: engagementLevelA,
    engagement_level_b: engagementLevelB,
    region_type: filterValue?.region_country_selector?.value?.type || 'region',
    region: filterValue?.region_country_selector?.value?.value || 'global',
    metric_filter: metricFilter,
    ...steamTagParams,
    ...genreParams,
  };
  return filterForm;
};

export const handleJapansaleFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const allGamesParams = getAllgamesFilterListParams(filterParams, 'console') || {};

  const filterForm: any = {
    granularity: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,

    genre: filterParams?.genre,
    sub_genre: filterParams?.sub_genre,
    genre_source: filterParams?.genre_source,
    iegg_genre_req: filterParams?.iegg_genre_req,

    start_release_time: filterParams?.start_release_time,
    end_release_time: filterParams?.end_release_time,
    company: filterParams?.company || [],
    ...allGamesParams,
  };
  return topchartFilterUndefinedValues(filterForm);
};

const resolveRetentionPlatforms = (platforms?: string[]) => {
  const selected = Array.isArray(platforms) ? platforms : [];
  if (selected.length === 1 && selected[0] === 'unified') {
    return ['appstore', 'googleplay'];
  }
  if (selected.length > 0) {
    return selected;
  }
  return ['appstore', 'googleplay'];
};

export const handleRetentionFilterParamsToApi = (filterParams: any, entityType: string) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const allGamesParams = getAllgamesFilterListParams(filterParams, entityType) || {};
  const filterGenres = buildTopChartsMultiSourceGenreFilterBlock(filterParams);
  const ieggGenreReq = Array.isArray(filterParams?.iegg_genre_req) &&
    filterParams.iegg_genre_req.length > 0
    ? filterParams.iegg_genre_req
    : Array.isArray(filterParams?.iegg_genre) && filterParams.iegg_genre.length > 0
      ? filterParams.iegg_genre
      : [];

  const filterForm: any = {
    region_type: filterParams?.region_type,
    regions: filterParams?.regions,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    date_type: filterParams?.date_type,
    genre: filterParams?.genre || [],
    sub_genre: filterParams?.sub_genre || [],
    genre_source: filterParams?.genre_source,
    iegg_genre: ieggGenreReq,
    appannie_genre: filterGenres.appannie_genre,
    sensortower_genre: filterGenres.sensortower_genre,
    ...(filterGenres.app_magic ? { app_magic: filterGenres.app_magic } : {}),
    company: filterParams?.company || [],
    platforms: resolveRetentionPlatforms(filterParams?.platforms),
    start_release_time: filterParams?.start_release_time,
    end_release_time: filterParams?.end_release_time,
    sensortower_tag_filter: filterParams?.sensortower_tag_filter || [],
    ...mergeTopChartsNewMobileFilter(filterParams, true),
    ...allGamesParams,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleStreamingGameFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    region_type: filterParams?.region_type,
    regions: filterParams?.regions,
    period: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    genre: filterParams?.genre || [],
    sub_genre: filterParams?.sub_genre || [],
    genre_source: filterParams?.genre_source,
    iegg_genre_req: filterParams?.iegg_genre_req || [],
    release_start_date: filterParams?.start_release_time,
    release_end_date: filterParams?.end_release_time,
    platform: filterParams?.kolPlatforms,
    company: filterParams?.company || [],
    game_type: filterParams?.streaming_gametype,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleRPDFilterParamsToApi = (filterParams: any, entityType: string) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const allGamesParams = getAllgamesFilterListParams(filterParams, entityType) || {};
  const filterForm: any = {
    region_type: filterParams?.region_type,
    regions: filterParams?.regions,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    start_release_time: filterParams?.start_release_time,
    end_release_time: filterParams?.end_release_time,
    date_type: filterParams?.date_type,
    company: filterParams?.company || [],
    sensortower_tag_filter: filterParams?.sensortower_tag_filter || [],
    datasource_sim: filterParams?.datasource_sim,
    genre: filterParams?.genre,
    sub_genre: filterParams?.sub_genre,
    genre_source: filterParams?.genre_source,
    iegg_genre_req: filterParams?.iegg_genre_req,
    appannie_genre: filterParams?.appannie_genre || [],
    sensortower_genre: filterParams?.sensortower_genre || [],
    iegg_genre: filterParams?.iegg_genre || [],
    appmagic_genre: filterParams?.appmagic_genre || [],
    ...mergeTopChartsNewMobileFilter(filterParams, true),
    ...allGamesParams,
    unified_ids: allGamesParams?.filter_ids || [],
  };
  return topchartFilterUndefinedValues(filterForm);
};

/**
 * Extract ARPU range params from filter state
 */
const extractArpuRangeParams = (filterParams: ITopChartsFilterParams): IArpuRangeParams => {
  const arpuRange = (filterParams as Record<string, { value?: { min?: number | string; max?: number | string } }>)?.[filterKeyMap.ARPU_RANGE]?.value || {};
  const arpuMin = arpuRange?.min;
  const arpuMax = arpuRange?.max;
  return {
    arpu_min: arpuMin === '' ? undefined : (arpuMin as number | undefined),
    arpu_max: arpuMax === '' ? undefined : (arpuMax as number | undefined),
  };
};

/**
 * Extract Active Users range params from filter state
 */
const extractActiveUsersRangeParams = (filterParams: ITopChartsFilterParams): IActiveUsersRangeParams => {
  const activeUsersRange = (filterParams as Record<string, { value?: { min?: number | string; max?: number | string } }>)?.[filterKeyMap.ACTIVE_USERS_RANGE]?.value || {};
  const auMin = activeUsersRange?.min;
  const auMax = activeUsersRange?.max;
  return {
    au_min: auMin === '' ? undefined : (auMin as number | undefined),
    au_max: auMax === '' ? undefined : (auMax as number | undefined),
  };
};

/**
 * Extract Downloads range params from filter state
 */
const extractDownloadsRangeParams = (filterParams: ITopChartsFilterParams): IDownloadsRangeParams => {
  const downloadsRange = (filterParams as Record<string, { value?: { min?: number | string; max?: number | string } }>)?.[filterKeyMap.DOWNLOADS_RANGE]?.value || {};
  const downloadsMin = downloadsRange?.min;
  const downloadsMax = downloadsRange?.max;
  return {
    downloads_min: downloadsMin === '' ? undefined : (downloadsMin as number | undefined),
    downloads_max: downloadsMax === '' ? undefined : (downloadsMax as number | undefined),
  };
};

/**
 * Build metric filter object with revenue and ARPU filters applied to each data source
 */
const buildMetricFilterByDataSource = (filterParams: ITopChartsFilterParams): IMetricFilterBySource | undefined => {
  if (!filterParams?.data_sources) {
    return undefined;
  }
  try {
    const metricFilter = filterParams.metric_filter as {
      revenueGrowth?: unknown[];
      revenueRange?: unknown[];
      arpuRange?: unknown[];
      activeUsersRange?: unknown[];
      downloadsRange?: unknown[];
    } | undefined;

    return filterParams.data_sources.reduce((result: IMetricFilterBySource, item: string) => {
      const revenueFilter: unknown[] = [];
      if (metricFilter?.revenueGrowth) {
        revenueFilter.push(...metricFilter.revenueGrowth);
      }
      if (metricFilter?.revenueRange) {
        revenueFilter.push(...metricFilter.revenueRange);
      }
      if (metricFilter?.arpuRange) {
        revenueFilter.push(...metricFilter.arpuRange);
      }
      if (metricFilter?.activeUsersRange) {
        revenueFilter.push(...metricFilter.activeUsersRange);
      }
      if (metricFilter?.downloadsRange) {
        revenueFilter.push(...metricFilter.downloadsRange);
      }
      result[item] = revenueFilter as IMetricFilterBySource[string];
      return result;
    }, {});
  } catch (err) {
    console.error(err);
    return {};
  }
};

/**
 * Resolve order source - fallback to first data source if current selection is invalid
 */
const resolveOrderSource = (filterParams: ITopChartsFilterParams): string | undefined => {
  const { order_source, data_sources } = filterParams;
  if (data_sources && !data_sources.includes(order_source as string)) {
    return data_sources[0];
  }
  return order_source;
};

export const handleActiveuserFilterParamsToApi = (
  filterParams: ITopChartsFilterParams,
  entityType: string,
): ITopChartsApiFilterForm => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const allGamesParams = getAllgamesFilterListParams(filterParams, entityType) || {};
  const arpuParams = extractArpuRangeParams(filterParams);
  const activeUsersParams = extractActiveUsersRangeParams(filterParams);
  const downloadsParams = extractDownloadsRangeParams(filterParams);
  const metricFilter = buildMetricFilterByDataSource(filterParams);
  const orderSource = resolveOrderSource(filterParams);

  const filterForm: ITopChartsApiFilterForm = {
    region_type: filterParams?.region_type,
    regions: filterParams?.regions,
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,

    genre: filterParams?.genre,
    sub_genre: filterParams?.sub_genre,
    genre_source: filterParams?.genre_source,
    iegg_genre_req: filterParams?.iegg_genre_req,
    platforms: filterParams?.platforms,

    start_release_time: filterParams?.start_release_time,
    end_release_time: filterParams?.end_release_time,
    company: filterParams?.company || [],
    revenue_scope: filterParams?.revenue_scope,
    adjusted_revenue: getAdjustedRevenueValue(filterParams?.revenue_scope),
    metric_filter: metricFilter,

    data_sources: filterParams?.data_sources,
    order_source: orderSource,
    sensortower_tag_filter: filterParams?.sensortower_tag_filter || [],
    ...arpuParams,
    ...activeUsersParams,
    ...downloadsParams,
    ...allGamesParams,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleActiveUsersFilterParamsToApi = (
  filterParams: ITopChartsFilterParams,
  entityType: string,
): ITopChartsApiFilterForm => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const allGamesParams = getAllgamesFilterListParams(filterParams, entityType) || {};
  const arpuParams = extractArpuRangeParams(filterParams);
  const activeUsersParams = extractActiveUsersRangeParams(filterParams);
  const downloadsParams = extractDownloadsRangeParams(filterParams);
  const metricFilter = buildMetricFilterByDataSource(filterParams);
  const orderSource = resolveOrderSource(filterParams);

  const filterForm: ITopChartsApiFilterForm = {
    region_type: filterParams?.region_type,
    regions: filterParams?.regions,
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,

    genre: filterParams?.genre,
    sub_genre: filterParams?.sub_genre,
    genre_source: filterParams?.genre_source,
    iegg_genre_req: filterParams?.iegg_genre_req,
    // Additional genre fields specific to this handler
    appannie_genre: filterParams?.appannie_genre || [],
    sensortower_genre: filterParams?.sensortower_genre || [],
    iegg_genre: filterParams?.iegg_genre || [],
    appmagic_genre: filterParams?.appmagic_genre || [],
    platforms: filterParams?.platforms,

    start_release_time: filterParams?.start_release_time,
    end_release_time: filterParams?.end_release_time,
    company: filterParams?.company || [],
    revenue_scope: filterParams?.revenue_scope,
    adjusted_revenue: getAdjustedRevenueValue(filterParams?.revenue_scope),
    metric_filter: metricFilter,

    data_sources: filterParams?.data_sources,
    order_source: orderSource,
    sensortower_tag_filter: filterParams?.sensortower_tag_filter || [],
    app_magic_tags: filterParams?.app_magic_tags || {},
    ...arpuParams,
    ...activeUsersParams,
    ...downloadsParams,
    game_engine: filterParams?.game_engine || [],
    game_engine_relation: (filterParams?.game_engine_relation || 'OR').toLowerCase(),
    ...allGamesParams,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleCasualGenreProfileFilterParamsToApi = (
  filterParams: ITopChartsFilterParams,
  entityType: string,
): ITopChartsApiFilterForm => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }

  const filterForm: ITopChartsApiFilterForm = {
    region_type: filterParams?.region_type,
    regions: filterParams?.regions,
    granularity: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,

    genre_source: filterParams?.genre_source,
    iegg_genre_req: filterParams?.iegg_genre_req,
    // Additional genre fields specific to this handler
    appannie_genre: filterParams?.appannie_genre || [],
    sensortower_genre: filterParams?.sensortower_genre || [],
    iegg_genre: filterParams?.iegg_genre || [],
    appmagic_genre: filterParams?.appmagic_genre || [],
    platforms: filterParams?.platforms,
    start_release_time: filterParams?.start_release_time,
    end_release_time: filterParams?.end_release_time,
    company: filterParams?.company || [],
    sensortower_tag_filter: filterParams?.sensortower_tag_filter || [],
    app_magic_tags: filterParams?.app_magic_tags || {},
  };

  return topchartFilterUndefinedValues(filterForm);
};

export const handlePotentialNewReleaseFilterParamsToApi = (
  filterParams: any,
  entityType: string,
) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const allGamesParams = getAllgamesFilterListParams(filterParams, entityType) || {};
  const filterForm: any = {
    plan: filterParams?.plan,
    // popularity_range: filterParams?.pheat_range,
    markets: filterParams?.regions,
    // start_release_time: filterParams?.start_release_time,
    // end_release_time: filterParams?.end_release_time,
    company: filterParams?.company || [],
    sensortower_tag_filter: filterParams?.sensortower_tag_filter || [],
    ...mergeTopChartsNewMobileFilter(filterParams),
    ...allGamesParams,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handlePotentialUpcomingFilterParamsToApi = (filterParams: any, entityType: string) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const allGamesParams = getAllgamesFilterListParams(filterParams, entityType) || {};
  // 若start_release_time，end_release_time为空，接口会报错，故在此处添加兜底，用默认值
  const start_release_time =
    filterParams?.start_release_time === '' ? START_RELEASE_TIME : filterParams?.start_release_time;
  const end_release_time =
    filterParams?.end_release_time === '' ? END_RELEASE_TIME : filterParams?.end_release_time;

  const filterForm: any = {
    plan: filterParams?.plan,
    // popularity_range: filterParams?.pheat_range,
    markets: filterParams?.regions,
    start_release_time,
    end_release_time,
    company: filterParams?.company || [],
    sensortower_tag_filter: filterParams?.sensortower_tag_filter || [],
    ...allGamesParams,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleDetailDigitalFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    regions: filterParams?.regions, // markets
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    segment: filterParams?.segment,
    device: filterParams?.device,
    platform_cascader: filterParams?.platform_cascader,
  };
  return topchartFilterUndefinedValues(filterForm);
};

/** Console Data 详情页筛选器参数（与 KPI Trends 一致，可从 filterValue 补全粒度） */
export const handleDetailConsoleDataFilterParamsToApi = (
  filterParams: any,
  filterValue?: any,
) => {
  const rangeTime = filterValue?.[filterKeyMap.RANGE_TIME];
  const periodFromValue =
    rangeTime?.granularity || toDateTypeLy[rangeTime?.type] || '';
  const period = filterParams?.date_type || periodFromValue;

  if (JSON.stringify(filterParams) === '{}' && !period) {
    return {};
  }

  const alineaPlatforms =
    filterParams?.platform_cascader?.alinea ??
    filterValue?.[filterKeyMap.PLATFORMCASCADER]?.value?.alinea;
  const filterForm: any = {
    period,
    date_type: period,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    segment: filterParams?.segment,
    metric_condition: getPlatformCacaderValues(
      { alinea: alineaPlatforms || [] },
      'platforms',
    ),
  };
  return topchartFilterUndefinedValues(filterForm);
};

// KPITrends页面参数
export const handleDetailKPITrendsFilterParamsToApi = (fetchParams: any, filterValue: any) => {
  if (JSON.stringify(filterValue) === '{}') {
    return fetchParams;
  }

  // console.log('handleDetailKPITrendsFilterParamsToApi-fetchParams', fetchParams);
  // console.log('handleDetailKPITrendsFilterParamsToApi-filterValue', filterValue);

  const rangeTimeValue = filterValue?.rangeTime?.value || [];
  const isHourlyRange = isKpiTrendsHourlyDateType(filterValue?.rangeTime?.type);
  const startDateTemp =
    Array.isArray(rangeTimeValue) && rangeTimeValue?.length > 1 ? rangeTimeValue[0] : '';
  const endDateTemp =
    Array.isArray(rangeTimeValue) && rangeTimeValue?.length > 1 ? rangeTimeValue[1] : '';
  let startDate = '';
  let endDate = '';
  if (isHourlyRange) {
    if (isValidDate(startDateTemp)) {
      startDate = formatKpiTrendsHourlyDateTime(startDateTemp, 'start');
    }
    if (isValidDate(endDateTemp)) {
      endDate = formatKpiTrendsHourlyDateTime(endDateTemp, 'end');
    }
  } else if (isValidDate(startDateTemp)) {
    startDate =
      toDateTypeNor[filterValue?.rangeTime?.type] === 'month'
        ? `${moment(startDateTemp).format('YYYY-MM')}-01`
        : moment(startDateTemp).format('YYYY-MM-DD');
  }
  if (!isHourlyRange && isValidDate(endDateTemp)) {
    endDate =
      toDateTypeNor[filterValue?.rangeTime?.type] === 'month'
        ? `${moment(endDateTemp).format('YYYY-MM')}-01`
        : moment(endDateTemp).format('YYYY-MM-DD');
  }

  // platforms转换
  const platformsValueTemp = filterValue?.metrictable_device?.value || [];
  const { ampere, ...rest } = filterValue?.platform_cascader?.value || {};
  const metricList =
    filterValue?.metric_selection_for_trends?.value?.metrics || [];
  const nonHourlyMetricList = metricList.filter(
    (m: string) => m !== KPI_TRENDS_HOURLY_CCU_METRIC,
  );
  const resolvedMetricList = nonHourlyMetricList.length
    ? nonHourlyMetricList
    : DEFAULTKPITRENDSSHOWRTLIST;

  const filterForm: any = {
    regions: filterValue?.region?.markets, // markets
    date_type: toDateTypeLy[filterValue?.rangeTime?.type],
    start_date: startDate,
    end_date: endDate,
    segment_list: filterValue?.digital_segment_multiple?.value,
    device: platformsValueTemp,
    source_metrics: isHourlyRange
      ? KPI_TRENDS_HOURLY_SOURCE_METRICS
      : getSourceMetricsByValue(resolvedMetricList),
    // metric_condition: getPlatformCacaderValues(
    //   filterValue?.cascader?.value || {},
    // ),
    metric_condition: merge(
      buildMetricConditionFromPlatformCascader(filterValue?.platform_cascader?.value),
      getPlatformCacaderValues(filterValue?.cascader?.value || {}),
    ),
    segmentsByDownload: filterValue?.cascadersByDownload?.value,
  } as any;
  if (filterValue.publisher) {
    if (filterForm.metric_condition.gsd) {
      filterForm.metric_condition.gsd = {
        ...filterForm.metric_condition.gsd,
        gsd_types: filterValue.publisher?.value === 'all' ? [] : [filterValue.publisher?.value],
      };
    } else {
      filterForm.metric_condition.gsd = {
        gsd_types: filterValue.publisher?.value === 'all' ? [] : [filterValue.publisher?.value],
      };
    }
  }
  return topchartFilterUndefinedValues(filterForm);
};

/** 各数据源 metric_condition 平台字段映射（topcharts_list / pcConsoleMetricData） */
export const METRIC_CONDITION_PLATFORM_FIELD_MAP: Record<string, string> = {
  mscience: 'platforms',
  gsd: 'device',
  gamalytic: 'platform',
  vginsights: 'platforms',
  ampere: 'platforms',
  alinea: 'platforms',
  npd: 'device',
  newzoo: 'device',
  noUpdate: 'device',
};

const METRIC_CONDITION_PLATFORM_LEGACY_KEYS = ['detailed_platforms', 'device', 'platforms'] as const;

/** 将 platform_cascader 筛选值转为 metric_condition 平台入参 */
export const buildMetricConditionFromPlatformCascader = (
  platformCascaderValue: Record<string, string[]> = {},
): Record<string, Record<string, string[]>> => {
  const result: Record<string, Record<string, string[]>> = {};
  Object.entries(platformCascaderValue).forEach(([source, values]) => {
    if (!Array.isArray(values) || values.length === 0) return;
    const field = METRIC_CONDITION_PLATFORM_FIELD_MAP[source];
    if (!field) return;
    result[source] = { [field]: values };
  });
  return result;
};

/** 规范化 metric_condition 中各数据源的平台字段名（仅重命名已有字段，不新增数据源或平台字段） */
export const normalizeMetricConditionForApi = (
  metricCondition?: Record<string, any>,
): Record<string, any> | undefined => {
  if (!metricCondition || typeof metricCondition !== 'object') return metricCondition;

  const normalized: Record<string, any> = {};

  Object.entries(metricCondition).forEach(([source, condition]) => {
    if (!condition || typeof condition !== 'object' || Array.isArray(condition)) {
      normalized[source] = condition;
      return;
    }

    const targetField = METRIC_CONDITION_PLATFORM_FIELD_MAP[source];
    if (!targetField) {
      normalized[source] = condition;
      return;
    }

    const legacyKey = METRIC_CONDITION_PLATFORM_LEGACY_KEYS.find((key) =>
      Object.prototype.hasOwnProperty.call(condition, key),
    );

    if (!legacyKey) {
      normalized[source] = condition;
      return;
    }

    const platformValues = condition[legacyKey];
    const otherFields = { ...condition };
    METRIC_CONDITION_PLATFORM_LEGACY_KEYS.forEach((key) => {
      delete otherFields[key];
    });

    normalized[source] = {
      ...otherFields,
      [targetField]: platformValues,
    };
  });

  return normalized;
};

import { forceDailyGranularityForPlayersByCountry } from './playersByCountryMetrics';

/** 规范化 topcharts_list / pcConsoleMetricData 请求体中的 metric_condition */
export const normalizePcConsoleTopChartsApiPayload = (payload: any): any => {
  if (!payload || typeof payload !== 'object') return payload;

  let result = { ...payload };

  if (result.metric_condition) {
    result.metric_condition = normalizeMetricConditionForApi(result.metric_condition);
  }

  if (result.metric_params?.download_params?.metric_condition) {
    result.metric_params = {
      ...result.metric_params,
      download_params: {
        ...result.metric_params.download_params,
        metric_condition: normalizeMetricConditionForApi(
          result.metric_params.download_params.metric_condition,
        ),
      },
    };
  }

  result = forceDailyGranularityForPlayersByCountry(result);

  return result;
};

export const getPlatformCacaderValues = (value: Record<string, string[]>, keys = 'segments') => {
  const tmpObj: Record<string, Record<string, string[]>> = {};
  Object.keys(value).forEach((key) => {
    tmpObj[key] = {
      [keys]: value[key],
    };
  });
  return tmpObj;
};

// ComparePCConsole页面参数
export const handleComparePCConsoleFilterParamsToApi = (fetchParams: any, filterValue: any) => {
  if (JSON.stringify(filterValue) === '{}') {
    return fetchParams;
  }

  const rangeTimeValue = filterValue?.rangeTime?.value || [];
  const rangeReleaseTimeValue = filterValue?.rangeReleaseTime?.value || [];
  const startDate =
    Array.isArray(rangeTimeValue) && rangeTimeValue?.length > 1 ? rangeTimeValue[0] : '';
  const endDate =
    Array.isArray(rangeTimeValue) && rangeTimeValue?.length > 1 ? rangeTimeValue[1] : '';
  const startReleaseData =
    Array.isArray(rangeReleaseTimeValue) && rangeReleaseTimeValue?.length > 1
      ? rangeReleaseTimeValue[0]
      : '';
  const endReleaseData =
    Array.isArray(rangeReleaseTimeValue) && rangeReleaseTimeValue?.length > 1
      ? rangeReleaseTimeValue[1]
      : '';

  const alignToRelease = filterValue.align_to_release?.value;

  // platforms转换
  const platformsValueTemp = filterValue?.metrictable_device?.value || [];
  // const platformsValue = platformsValueTemp?.includes('PlayStation')
  //   ? [...platformsValueTemp, 'PlayStation 4', 'PlayStation 5']
  //   : platformsValueTemp;
  const filterForm: any = {
    ...fetchParams,
    ids: filterValue?.allGames?.value, // markets
    granularity: alignToRelease
      ? toDateTypeLy[filterValue?.rangeReleaseTime?.type]
      : toDateTypeLy[filterValue?.rangeTime?.type],
    start_date:
      isValidDate(startDate) && !alignToRelease ? moment(startDate).format('YYYY-MM-DD') : '',
    end_date: isValidDate(endDate) && !alignToRelease ? moment(endDate).format('YYYY-MM-DD') : '',
    start_release_time: alignToRelease ? parseInt(startReleaseData, 10) : 0,
    end_release_time: alignToRelease ? parseInt(endReleaseData, 10) : 0,
    metric_condition: merge(
      buildMetricConditionFromPlatformCascader(filterValue?.platform_cascader?.value),
      getPlatformCacaderValues(filterValue?.cascader?.value || {}),
    ),
    // segments: filterValue?.digital_segment_multiple?.value,
    markets: filterValue?.region?.markets,
    platforms: platformsValueTemp,
    source_metrics: filterValue?.metric_selection_for_trends?.value?.source_metrics,
    segmentsByDownload: filterValue?.cascadersByDownload?.value,
  } as any;
  return filterForm;
};

// PCConsoleTopCharts页面参数
export const handlePCConsoleTopChartsFilterParamsToApi = (
  fetchParams: any = {},
  filterValue: any = {},
  apiValue: any = {},
) => {
  if (JSON.stringify(filterValue) === '{}') {
    return fetchParams;
  }

  const startDate = getCommonTimeFilterValues(filterValue, 0);
  const endDate = getCommonTimeFilterValues(filterValue, 1);
  const metricRange = handleMetricRangeFilter(filterValue);

  const filterForm: any = {
    ...fetchParams,
    company: filterValue[filterKeyMap.PUBLISHER_COMPANY]?.value || [],
    developer: filterValue[filterKeyMap.DEVELOPER]?.value || [],
    publisher_class: filterValue[filterKeyMap.PUBLISHER_CLASS]?.value || [],
    publisher_region: filterValue[filterKeyMap.PUBLISHER_REGION]?.markets || [],
    date_type: toDateTypeLy[filterValue[filterKeyMap.RANGE_TIME]?.type],
    start_date: startDate,
    end_date: endDate,
    filter_ids: filterValue[filterKeyMap.ALL_Games]?.value || [],
    steam_tag: filterValue[filterKeyMap.STEAM_TAGS]?.value || [],
    steam_tag_relation: (filterValue[filterKeyMap.STEAM_TAGS]?.logic || 'AND').toLowerCase(),
    game_mode: filterValue[filterKeyMap.GAME_MODE]?.value,
    game_engine: filterValue[filterKeyMap.GAME_ENGINE]?.value || [],
    game_engine_relation: (filterValue[filterKeyMap.GAME_ENGINE]?.logic || 'OR').toLowerCase(),
    source_metrics: fetchParams?.source_metrics,
    regions: filterValue[filterKeyMap.REGION]?.markets,
    device: filterValue[filterKeyMap.METRICTABLE_DEVICE]?.value,
    iegg_genre_req: apiValue[filterKeyMap.GENRETOR]?.iegg_genre_req || [],
    start_release_time: apiValue[filterKeyMap.RELEASE_TIME]?.start_release_time || '',
    end_release_time: apiValue[filterKeyMap.RELEASE_TIME]?.end_release_time || '',
    ...metricRange,
    platform_cascader: filterValue.platform_cascader?.value || apiValue.platform_cascader?.value,
    publisher:
      filterValue[filterKeyMap.PUBLISHER]?.value || apiValue[filterKeyMap.PUBLISHER]?.value,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleDetailPCUFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleCombineDetailStoreRankFilterParamsToApi = (
  filterParams: any,
  filterValue: any,
) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  // console.log('handleCombineDetailStoreRankFilterParamsToApi-filterParams', filterParams);
  // console.log('handleCombineDetailStoreRankFilterParamsToApi-filterValue', filterValue);
  const startDate = getCommonTimeFilterValues(filterValue, 0);
  const endDate = getCommonTimeFilterValues(filterValue, 1);

  let filterForm: any = {
    ...filterParams,
    granularity: toDateTypeLy[filterValue?.rangeTime?.type],
    start_date: startDate,
    end_date: endDate,
  };

  if (filterValue?.storerank_segement?.value === 'rank') {
    const platformValue = filterValue?.composed_select?.value?.parent || '';
    const metricObjList =
      STORERANK_METRICS_OPTIONS_LIST.filter((item: any) => item.dataSource === platformValue) || [];

    const regionsValue = CONSOLE_PLATFORMS.includes(platformValue)
      ? filterValue?.composed_country_select?.value?.countries
      : filterValue?.region?.markets;

    filterForm = {
      ...filterForm,
      source: metricObjList?.map((item: any) => item.value),
      regions: regionsValue || [],
      platform: platformValue || '',
      segement: filterValue?.storerank_segement?.value,
      ext_fields: {},
    };
  } else {
    const platformValue = filterValue?.composed_select?.value?.parent || '';

    const regionsValue = CONSOLE_PLATFORMS.includes(platformValue)
      ? filterValue?.composed_country_select?.value?.countries
      : filterValue?.region?.markets;

    filterForm = {
      ...filterForm,
      source: [filterValue?.composed_select?.value?.child],
      regions: regionsValue || [],
      platform: platformValue || '',
      segement: filterValue?.storerank_segement?.value,
      ext_fields: {
        market_count: {},
      },
    };
  }

  return topchartFilterUndefinedValues(filterForm);
};

export const handleDetailPhysicalFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    device: filterParams?.device,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleDetailGSDFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    regions: filterParams?.regions, // markets
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    segment: filterParams?.gsdSegment,
    device: filterParams?.device,
    gsd_types: filterParams?.gsd_types,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleCompiniesFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    datasource_sim: filterParams?.datasource_sim,
    regions: filterParams?.regions, // markets
    granularity: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    genre: filterParams?.genre,
    sub_genre: filterParams?.sub_genre,
    genre_source: filterParams?.genre_source,
    iegg_genre_req: filterParams?.iegg_genre_req,
    game_type: filterParams?.companies_gametype,
    listed: filterParams?.companies_ipostatus,
    company_headquarter: filterParams?.companies_headquaters,
    revenue_range_unit: filterParams?.companies_revenuerange,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleDetailActiveRevenueDownloadFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    region_type: 'market',
    regions: filterParams?.regions, // markets
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    source: filterParams?.datasource_sim,
    platforms: filterParams?.platforms,
    revenue_scope: filterParams?.revenue_scope,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleDetailRetentionFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    region_type: 'market',
    regions: filterParams?.regions, // markets
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    metrics: filterParams?.retention_metrics,
    platforms: filterParams?.platforms,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleDetailRPDFilterParamsToApi = (filterParams: any) => {
  // datasource_sim: filterParams?.datasource_sim,
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    region_type: 'market',
    regions: filterParams?.regions, // markets
    date_type: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    platforms: filterParams?.platforms,
    data_source: filterParams?.datasource_sim ? [filterParams?.datasource_sim] : ['sensortower'],
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleDetailStreamingFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    period: filterParams?.date_type,
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    platform: filterParams?.streaming_platform,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const handleDetailDemographicsFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    markets: filterParams?.regions, // markets
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
    app_ids: filterParams?.app_ids ? [filterParams?.app_ids] : undefined,
    source: filterParams?.data_sources,
  };
  return topchartFilterUndefinedValues(filterForm);
};
export const handleDetailSteamsalesFilterParamsToApi = (filterParams: any) => {
  if (JSON.stringify(filterParams) === '{}') {
    return {};
  }
  const filterForm: any = {
    period: filterParams?.date_type, // markets
    start_date: filterParams?.start_date,
    end_date: filterParams?.end_date,
  };
  return topchartFilterUndefinedValues(filterForm);
};

export const USERSAVEKEY_COMPARE_PCCONSOLE = 'usersave-compare-pcconsole-games';
export const USERSAVEKEY_KPITRENDS = 'usersave-pcconsole-games-kpitrends';

// 用户保存指标和时间粒度
export const getUserSaveParams = (filterValue: any, saveKey: string) => {
  const {
    metric_selection_for_trends: metricSelectionForTrends = {},
    rangeTime: rangeTimeTemp = {},
    allGames = {},
  } = filterValue || {};
  switch (saveKey) {
    case USERSAVEKEY_COMPARE_PCCONSOLE:
      return {
        allGames,
        metric_selection_for_trends: metricSelectionForTrends,
        rangeTime: {
          ...rangeTimeTemp,
          value: ['', ''],
        },
      };
    case USERSAVEKEY_KPITRENDS:
      return {
        metric_selection_for_trends: metricSelectionForTrends,
        rangeTime: {
          ...rangeTimeTemp,
          value: ['', ''],
        },
      };
  }
};
